"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDateTimeField = void 0;
const react_1 = __importDefault(require("react"));
const date_time_field_1 = require("../date-time-field/date-time-field");
function LocalDateTimeField(props) {
    return react_1.default.createElement(date_time_field_1.DateTimeField, Object.assign({}, props, { representation: "local-date-time" }));
}
exports.LocalDateTimeField = LocalDateTimeField;
//# sourceMappingURL=local-date-time-field.js.map